module.exports = __webpack_public_path__ + "images/playerData-c4f70c86baeaab1d159a1d30f9f7c91b.svg";